// role-picker.js — 角色选择模态框
import { createRoleIcon } from "./view-helpers.js";
import { closeModalDialog, openModalDialog } from "../../interaction/ui/modal-dialog.js";

let onPickCb = null;
let initialized = false;

export function init({ onPick } = {}) {
  onPickCb = onPick;
  if (initialized) return;
  initialized = true;

  const list = document.getElementById("aichat-role-list");
  const close = document.getElementById("aichat-role-close");
  const cancel = document.getElementById("aichat-role-cancel-btn");

  list?.addEventListener("click", async (event) => {
    const item = event.target.closest(".aichat-role-item");
    if (!item) return;
    hide();
    await onPickCb?.(item.dataset.roleCode);
  });
  close?.addEventListener("click", hide);
  cancel?.addEventListener("click", hide);
}

function createRolePickerItem(role = {}) {
  const item = document.createElement('li');
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'aichat-role-item';
  button.dataset.roleCode = String(role.code || '');
  const icon = document.createElement('div');
  icon.className = 'aichat-role-icon';
  icon.append(createRoleIcon(role.code));
  const copy = document.createElement('div');
  copy.className = 'aichat-role-copy';
  const name = document.createElement('div');
  name.className = 'aichat-role-name';
  name.textContent = String(role.name || '');
  const description = document.createElement('div');
  description.className = 'aichat-role-desc';
  description.textContent = String(role.description || '');
  const provider = document.createElement('div');
  provider.className = 'aichat-role-provider';
  provider.textContent = `${role.defaultProvider || '默认'} · ${role.defaultModel || '默认模型'}`;
  copy.append(name, description, provider);
  button.append(icon, copy);
  item.append(button);
  return item;
}

export function show(roleList) {
  const list = document.getElementById("aichat-role-list");
  if (list) list.replaceChildren(...(roleList || []).map(createRolePickerItem));
  const backdrop = document.getElementById("aichat-role-backdrop");
  openModalDialog(backdrop, { onRequestClose: hide });
}

export function hide() {
  const backdrop = document.getElementById("aichat-role-backdrop");
  closeModalDialog(backdrop);
}
